import { useQuery } from "@tanstack/react-query";

import { IDENTIFY_CUSTOMER_STORE_KEY } from "@krea/customer-features/store/queryClient";

import { identifyCustomer } from "@/services/api/auth/identify";

export const useGetIdentifyCustomerData = (identifyToken: string) => {
  return useQuery({
    queryKey: [IDENTIFY_CUSTOMER_STORE_KEY, identifyToken],
    queryFn: async () => {
      const response = await identifyCustomer(identifyToken);

      return response.data;
    },
    enabled: !!identifyToken,
    staleTime: Infinity,
    retry: 1,
  });
};
